export const getMuscardinFranceData = () => ({
  name: "Muscardin",
  country: "France",
  description: "Muscardin est un cépage rouge très rare originaire du sud de la France, principalement cultivé dans l'appellation Châteauneuf-du-Pape où il apporte des notes aromatiques uniques.",
  regions: [
    { name: "Châteauneuf-du-Pape", area: "25 ha", percentage: "1%", description: "Cépage très rare, apportant des notes aromatiques uniques" },
    { name: "Côtes du Rhône", area: "10 ha", percentage: "0.3%", description: "Utilisé dans quelques assemblages traditionnels" },
    { name: "Languedoc-Roussillon", area: "5 ha", percentage: "0.1%", description: "Cultivé dans quelques domaines expérimentaux" },
    { name: "Autres", area: "5 ha", percentage: "0.1%", description: "Dispersé dans le sud de la France" }
  ],
  mapAreas: [
    { region: "Châteauneuf-du-Pape", x: 52, y: 68, color: "#4B164C", size: 1 },
    { region: "Côtes du Rhône", x: 50, y: 65, color: "#6d2c7a", size: 1 }
  ],
  characteristics: {
    viticulture: "Cépage très rare et difficile à cultiver, sensible aux maladies",
    climate: "Préfère les climats chauds et secs du sud de la France",
    soil: "Sols calcaires et argileux, bien drainés"
  },
  wineStyles: {
    red: "Vins rouges aromatiques avec des notes de musc, d'épices douces et d'élégance"
  },
  foodPairing: "Viandes blanches, volailles, poissons, cuisine provençale, fromages frais",
  history: "Muscardin est un cépage très ancien et rare, mentionné dans les textes historiques. Son nom évoque le musc, en référence à ses notes aromatiques caractéristiques. Il est aujourd'hui principalement cultivé dans Châteauneuf-du-Pape où il apporte une complexité aromatique unique aux assemblages."
}); 